const bankData = [
  {
    code: '004',
    name: '臺灣銀行'
  },
  {
    code: '005',
    name: '土地銀行'
  },
  {
    code: '006',
    name: '合作金庫銀行'
  },
  {
    code: '007',
    name: '第一銀行'
  },
  {
    code: '008',
    name: '華南銀行'
  },
  {
    code: '009',
    name: '彰化銀行'
  },
  {
    code: '011',
    name: '上海商業儲蓄銀行'
  },
  {
    code: '012',
    name: '台北富邦銀行'
  },
  {
    code: '013',
    name: '國泰世華銀行'
  },
  {
    code: '017',
    name: '兆豐國際商業銀行'
  },
  {
    code: '021',
    name: '花旗銀行'
  },
  {
    code: '025',
    name: '台灣企銀'
  },
  {
    code: '039',
    name: '澳盛銀行'
  },
  {
    code: '050',
    name: '台灣中小企業銀行'
  },
  {
    code: '052',
    name: '渣打國際商業銀行'
  },
  {
    code: '053',
    name: '台中商業銀行'
  },
  {
    code: '054',
    name: '京城商業銀行'
  },
  {
    code: '081',
    name: '匯豐銀行'
  },
  {
    code: '101',
    name: '瑞興商業銀行'
  },
  {
    code: '102',
    name: '華泰商業銀行'
  },
  {
    code: '103',
    name: '新光銀行'
  },
  {
    code: '108',
    name: '陽信商業銀行'
  },
  {
    code: '118',
    name: '板信商業銀行'
  },
  {
    code: '147',
    name: '三信商業銀行'
  },
  {
    code: '803',
    name: '聯邦銀行'
  },
  {
    code: '805',
    name: '遠東商業銀行'
  },
  {
    code: '806',
    name: '元大銀行'
  },
  {
    code: '807',
    name: '永豐銀行'
  },
  {
    code: '808',
    name: '玉山銀行'
  },
  {
    code: '809',
    name: '凱基銀行'
  },
  {
    code: '810',
    name: '星展銀行'
  },
  {
    code: '812',
    name: '台新銀行'
  },
  {
    code: '814',
    name: '大眾商業銀行'
  },
  {
    code: '815',
    name: '日盛國際商業銀行'
  },
  {
    code: '816',
    name: '安泰商業銀行'
  },
  {
    code: '822',
    name: '中國信託商業銀行'
  }
]

export default bankData
